module.exports = __webpack_public_path__ + "media/packs/images/transit/vessel-0725732d45ba4b772f0ce0e057fcb63e.svg";